/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { defineMessages, useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Panel } from 'primereact/panel';
import { NotificationContext } from '../../components/GrowlNotifications';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import ManagedAccounts from './ManagedAccounts';

const MANAGE_ACCOUNTS_CONFIG_QUERY = gql`
  query manageAccountsConfigQuery($accountId: ID!) {
    account(id: $accountId) {
      managedAccounts {
        id
        displayName
        type
        paidBy
        status
        parent {
          id
          displayName
          type
        }
      }
    }
  }
`;

const i18nMessages = defineMessages({
  manageNoLimit: {
    id: 'business-center.manage-no-limit',
    defaultMessage: 'Manage NoLimit',
  },
});

const ManageAccounts = () => {
  const { formatMessage } = useIntl();
  const { aid: accountId } = useParams();
  const growl = useContext(NotificationContext);
  const history = useHistory();

  const [accounts, setAccounts] = useState([]);

  const { loading, error, data } = useQuery(MANAGE_ACCOUNTS_CONFIG_QUERY, {
    variables: {
      accountId,
    },
    fetchPolicy: 'no-cache',
  });

  const { account } = data;

  useEffect(() => {
    if (account) {
      setAccounts(account.managedAccounts);
    }
  }, [account]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-sm-12 p-md-12 p-lg-12">
            <Panel header={formatMessage(i18nMessages.manageNoLimit)}>
              <ManagedAccounts
                accounts={accounts}
                handleRowClick={clientId => history.push(`/accounts/${accountId}/managed-account-details?clientId=${clientId}`)}
              />
            </Panel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAccounts;
